import { render, staticRenderFns } from "./teamResult.vue?vue&type=template&id=c433d916&scoped=true"
import script from "./teamResult.vue?vue&type=script&lang=js"
export * from "./teamResult.vue?vue&type=script&lang=js"
import style0 from "./teamResult.vue?vue&type=style&index=0&id=c433d916&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c433d916",
  null
  
)

export default component.exports